module.exports = __webpack_public_path__ + "images/59df2c945ce14fd0b37f098c49ac1d9f.svg";